import * as React from "react";
type Props = {
  className?: string,
};
function SvgPepper2({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-pepper2"
      className={className}
    >
      <mask
        id="mask0_21_1568"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_21_1568)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.9904 12.4045L10.7226 14.1374C10.2201 15.8452 9.04497 16.8724 7.31623 17.4487C7.12799 17.5114 6.93604 17.5687 6.72456 17.6261L6.50599 17.6838L5.49058 17.9398L5.25455 18.0109L5.16037 18.0437L5.0805 18.0751L5.017 18.103L5.03504 18.1588C5.35689 18.9142 7.82769 19.8611 9.62037 19.9862L9.81662 19.9966L10 20C12.0689 20 13.8361 19.5032 15.2426 18.6578L16.6919 20.1058C14.9177 21.293 12.6515 22 10 22C9.63938 22 9.26247 21.977 8.87862 21.9322L8.49281 21.8801L8.04889 21.8031C5.52977 21.3146 3 19.944 3 18C3 16.8075 3.66985 16.3537 5.11162 15.9706L5.31302 15.9187L5.86309 15.7832L6.36792 15.6491L6.68377 15.5513C8.16114 15.0589 8.89952 14.2429 8.9904 12.4045ZM4.70711 3.29289L21.7071 20.2929L20.2929 21.7071L3.29289 4.70711L4.70711 3.29289ZM13 2C15.2572 2 16.679 3.87429 16.6277 6.08903C19.4141 6.55069 21 8.76759 21 12C21 13.6091 20.6254 15.1441 19.922 16.5071L18.4171 15.0018C18.7221 14.2602 18.9109 13.4658 18.9752 12.6399C17.9881 12.2545 16.8041 12.041 15.4209 12.0053L13.48 10.0659C13.9669 10.0219 14.4736 10 15 10C16.422 10 17.7001 10.1597 18.8324 10.4835C18.4316 8.85817 17.306 8 15.5 8C14.2837 8 13.2148 8.37227 12.4243 9.00877L11.0033 7.58906C11.9693 6.75583 13.2239 6.20926 14.6299 6.04901C14.6663 4.92108 14.058 4.07728 13.1304 4.00503L13 4V2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
export default SvgPepper2;
